<template>
  <!-- 右下角弹窗 -->
  <div class="dialog">
    <div class="header">
      <span>{{ title }}</span>
      <i
        class="el-icon-close"
        style="cursor: pointer"
        v-if="needCloseIcon"
        @click="$emit('close')"
      ></i>
    </div>
    <div class="content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RBDialog',
  props: {
    title: {
      type: String,
    },
    needCloseIcon: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog {
  position: absolute;
  min-width: 200px;
  bottom: 20px;
  right: 30px;
  background-color: #fff;
  border: 1px solid #dcdfe6;

  .header {
    padding: 0 10px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #dcdfe6;
  }

  .content {
    padding: 10px;
  }
}
</style>
